import { defineMessages } from 'react-intl';

export default defineMessages({
    groupProgramEligibilityTitle: {
        id: 'ml.quoteandbind.views.billing-details.Group Discount Payroll Deduct Eligibility',
        defaultMessage: 'Group Discount Payroll Deduct Eligibility',
    },
    paymentMethodTitle: {
        id: 'ml.quoteandbind.views.billing-details.Payment Method',
        defaultMessage: 'Payment Method'
    },
    paymentFrequencyTitle: {
        id: 'ml.quoteandbind.views.billing-details.Payment Frequency',
        defaultMessage: 'Payment Frequency'
    },
    paymentDetailsTitle: {
        id: 'ml.quoteandbind.views.billing-details.Payment Details',
        defaultMessage: 'Payment Details'
    },
    downPaymentTitle: {
        id: 'ml.quoteandbind.views.billing-details.Down Payment',
        defaultMessage: 'Down Payment'
    },
    groupDiscountDescription: {
        id: 'ml.quoteandbind.views.billing-details.You may choose to provide the following information to determine your eligibility for our group program. For the best results, enter complete name or as many characters as possible.',
        defaultMessage: 'You may choose to provide the following information to determine your eligibility for our group program. For the best results, enter complete name or as many characters as possible.'
    },
    groupDiscountEligibilityQuestion: {
        id: 'ml.quoteandbind.views.billing-details.Would you like to determine eligibility for our group program?',
        defaultMessage: 'Would you like to determine eligibility for our group program?'
    },
    PaymentPlanFaqSection: {
        id: 'ml.quoteandbind.views.billing-details.PaymentPlanFaqSection',
        defaultMessage: 'The Monthly option means your payment will occur each month on the same calendar date. The Twice a Month option means you select the first deduction date and the second deduction date will occur 15 calendar days later. Please note that if you select your first deduction to begin in the last half of the month, the second deduction will occur in the first half of the following month. Read more": "The Monthly option means your payment will occur each month on the same calendar date.  The Twice a Month option means you select the first deduction date and the second deduction date will occur 15 calendar days later.  Please note that if you select your first deduction to begin in the last half of the month, the second deduction will occur in the first half of the following month. Read more'
    },
    Continue: {
        id: 'ml.quoteandbind.views.billing-details.Continue',
        defaultMessage: 'Continue'
    },
    Next: {
        id: 'ml.quoteandbind.views.billing-details.Next',
        defaultMessage: 'Next'
    },
    Edit: {
        id: 'ml.quoteandbind.views.billing-details.Edit',
        defaultMessage: 'Edit'
    },
    EditAccount: {
        id: 'ml.quoteandbind.views.billing-details.Edit account',
        defaultMessage: 'Edit account'
    },
    MakePayment: {
        id: 'ml.quoteandbind.views.billing-details.Make Payment',
        defaultMessage: 'Make Payment'
    },
    YourPolicySummary: {
        id: 'ml.quoteandbind.views.billing-details.Your Policy Summary',
        defaultMessage: 'proceed to your policy summary'
    },
    ProceedToPolicySummary: {
        id: 'ml.quoteandbind.views.billing-details.We\'ll proceed to your policy summary next',
        defaultMessage: 'We\'ll {YourPolicySummary} next'
    },
    YourPayment: {
        id: 'ml.quoteandbind.views.billing-details.Your Payment',
        defaultMessage: 'your payment'
    },
    ProcessYourPayment: {
        id: 'ml.quoteandbind.views.billing-details.We\'ll process your payment next',
        defaultMessage: 'We\'ll process {YourPayment} next'
    },
    PaymentScheduleSubHeader: {
        id: 'ml.quoteandbind.views.billing-details.x on x',
        defaultMessage: '{paymentPlan} on {paymentSchedule}'
    },
    PaymentDetailsSubHeader: {
        id: 'ml.quoteandbind.views.billing-details.x - ending in x',
        defaultMessage: '{nickname} - ending in {last4Digits}'
    },
    Mortgage: {
        id: 'ml.quoteandbind.views.billing-details.Mortgage',
        defaultMessage: 'Mortgage'
    },
    AnnualPayment: {
        id: 'ml.quoteandbind.views.billing-details.Annual payment',
        defaultMessage: 'Annual payment'
    },
    MonthlyPayment: {
        id: 'ml.quoteandbind.views.billing-details.Monthly payment',
        defaultMessage: 'Monthly payment'
    },
    TwicePerMonth: {
        id: 'ml.quoteandbind.views.billing-details.Twice per month',
        defaultMessage: 'Twice per month'
    },
    TwoPay: {
        id: 'ml.quoteandbind.views.billing-details.Two pay',
        defaultMessage: 'Two pay'
    },
    FourPay: {
        id: 'ml.quoteandbind.views.billing-details.Four pay',
        defaultMessage: 'Four pay'
    },
    PayrollDeduct: {
        id: 'ml.quoteandbind.views.billing-details.Payroll deduct',
        defaultMessage: 'Payroll deduct'
    },
    AddAccount: {
        id: 'ml.quoteandbind.views.billing-details.Add account',
        defaultMessage: 'Add account'
    },
    nextBaseDescription: {
        id: 'ml.policychange.billing-details.nextBaseDescription',
        defaultMessage: 'We\'ll check if {bold} next'
    },
    nextDescriptionBold: {
        id: 'ml.policychange.billing-details.nextDescriptionBold',
        defaultMessage: 'additional changes are needed'
    },
    PrintApplication: {
        id: 'ml.quoteandbind.views.billing-details.VIEWPRINT APPLICATION',
        defaultMessage: 'VIEW/PRINT APPLICATION'
    },
    ApplicationUnavailable: {
        id: 'ml.quoteandbind.views.billing-details.Application Download Unavailable',
        defaultMessage: 'Application Download Unavailable'
    },
    changingPaymentMethodAffectPremium: {
        id: 'ml.quoteandbind.views.billing-details.Changing payment method may affect premium.',
        defaultMessage: 'Changing payment method may affect premium.'
    },
    changingGroupEligibilityAffectPremium: {
        id: 'ml.quoteandbind.views.billing-details.Changing payment method or updating group eligibility information may change premium',
        defaultMessage: 'Changing payment method or updating group eligibility information may change premium'
    },
    updatedBillingDetails: {
        id: 'ml.quoteandbind.views.billing-details.Updated Billing Details',
        defaultMessage: 'Updated Billing Details'
    },
    billingDetail: {
        id: 'ml.policychange.billing.Billing Details',
        defaultMessage: 'Billing details'
    },
    makeChanges: {
        id: 'ml.policychange.billing.makeChanges',
        defaultMessage: 'Make Changes'
    },
    gpcRemovedInNonPayroll: {
        id: 'ml.policychange.billing.gpcRemovedInNonPayroll',
        defaultMessage: 'Select a Group and Paypoint to continue, or click Cancel.'
    },
    eligRequiredMsg: {
        id: 'ml.policychange.billing.eligRequiredMsg',
        defaultMessage: 'Please complete the eligibility to continue!'
    },
    paypointChangedMsg: {
        id: 'ml.policychange.billing.paypointChangedMsg',
        defaultMessage: 'Group Information Change is not allowed when policy is on Payroll Deduction'
    },
    transferToPayrollMessage: {
        id: 'ml.policychange.billing.transferToPayrollMessage',
        defaultMessage: 'Transfer to Payroll: Policy Pay Plan must be Payroll Deduction'
    },
    billingDetailsMessage: {
        id: 'ml.policychange.billing.billingDetailsMessage',
        defaultMessage: 'To Change the Policy Pay Plan to Payroll Deduction Transaction must be Transfer to Payroll'
    },
    eligibilityVerificationIncomplete: {
        id: 'ml.policychange.billing.eligibilityVerificationIncomplete',
        defaultMessage: 'Missing Group Eligibility Name/Address. Please complete the Eligibility Search one more time.'
    }
});
